import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50.71",
  height: "50.447",
  viewBox: "0 0 12.71 12.447"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Group_2868",
  transform: "translate(-8791 -4176)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2547",
    d: "m7.231 28.148-.853-.848a.408.408 0 0 0-.575.58l.971.913c.076.076.179.058.287.058h.79a5.237 5.237 0 0 0-1.069 2.4H5.406a.424.424 0 0 0 0 .847h1.318a4.26 4.26 0 0 0 .5 1.977h-.297a.425.425 0 0 0-.287.138l-.971.984a.411.411 0 0 0 0 .578.4.4 0 0 0 .573 0l.853-.855h.655a4.7 4.7 0 0 0 3.322 1.7v-8.472z",
    fill: "#d9352a",
    class: "cls-1",
    transform: "translate(8786 4151.818)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2548",
    d: "M57.667 31.2H56.26a6.3 6.3 0 0 0-1.155-2.4h.9c.108 0 .211.019.287-.057l.971-.943a.387.387 0 0 0 0-.558.405.405 0 0 0-.574 0l-.852.853H52v8.478a5.289 5.289 0 0 0 3.3-1.7h.678l.853.856a.405.405 0 1 0 .574-.572l-.971-.993a.425.425 0 0 0-.287-.138h-.311a4.218 4.218 0 0 0 .5-1.977h1.328a.424.424 0 0 0 0-.847z",
    fill: "#d9352a",
    class: "cls-1",
    transform: "translate(8745.638 4151.875)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2549",
    d: "M31.421 9.318h5.247a2.516 2.516 0 0 0-1.227-2.2l.53-.519a.4.4 0 0 0 0-.568.406.406 0 0 0-.574 0l-.766.767a2.568 2.568 0 0 0-1.174 0l-.766-.766a.406.406 0 1 0-.574.574l.53.508a2.516 2.516 0 0 0-1.226 2.204z",
    fill: "#d9352a",
    class: "cls-1",
    transform: "translate(8763.311 4170.083)"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };